import { AlertTriangle, X } from "lucide-react";

interface Props {
  message: string;
  onClose: () => void;
}

/**
 * Inline notice shown under the GG header when enabling push notifications
 * failed. The bell only carried the reason in its tooltip, so e.g. on Brave
 * (permission granted, subscription rejected) the user saw nothing happen.
 */
export function PushErrorNotice({ message, onClose }: Props) {
  return (
    <div
      role="alert"
      className="flex flex-shrink-0 items-start gap-2 border-b border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700 sm:px-4"
    >
      <AlertTriangle size={14} className="mt-0.5 flex-shrink-0" />
      <p className="flex-1 leading-snug">{message}</p>
      <button
        type="button"
        onClick={onClose}
        title="Zamknij"
        className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded text-red-400 hover:bg-red-100 hover:text-red-700"
      >
        <X size={12} />
      </button>
    </div>
  );
}
